import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const SubmissionWarningModal = ({ isOpen }) => {
  const [countdown, setCountdown] = useState(5);
  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen) {
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev === 1) {
            clearInterval(timer);
            navigate("/time-sheet");
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [isOpen, navigate]);

  if (!isOpen) return null;

  return (
    <div
      className="modal centered delete-modal fade show"
      style={{ display: "block" }}
      aria-labelledby="submissionWarningModalLabel"
      aria-hidden={!isOpen}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="text-center">
            <p style={{ fontSize: "20px", fontWeight: "600" }}>
              Timesheet has already been submitted
            </p>
            <p className="text-muted">Redirecting to home in {countdown}...</p>
          </div>
          <div className="modal-footer justify-content-center">
            <button
              type="button"
              className="primary-btn me-3"
              onClick={() => navigate("/time-sheet")}
            >
              Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubmissionWarningModal;
